import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { getDemoClassById } from "../../store/middleware";
import DemoClassDetailsContent from "./DemoClassDetailsContent";
import scheduleIcon from "../../assets/images/icons/icon_schedule_header.svg";

function DemoClassDetails({ userClass }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { demoClass } = useSelector((state) => state.genericReducer);

  const loadInfos = async () => {
    await dispatch(getDemoClassById(userClass?.container?.demoClassId));
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view new-view">
      <SideMenu />
      <section>
        <Header title={t("CARD_CLASS_DETAILS")} icon={scheduleIcon} t={t} />
        {demoClass !== null && <DemoClassDetailsContent userClass={userClass} />}
      </section>
    </div>
  );
}

export default DemoClassDetails;
